<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
}
</style>

<template>
<div class="verAddCon"  v-if='showModel'>
        <div class="title">{{$t('appVersion.addButton')}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
             <Tabs type="card">
                 <TabPane :label="$t('firmwareVersion.addBox.title1')">
                    <FormItem :label="$t('editMesageModule.lang_zh')" prop="zh" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.zh" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_zh_ft')" prop="zh_ft" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.zh_ft" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_en')" prop="en" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.en" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_fr')" prop="fr" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.fr" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_de')" prop="de" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.de" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_es')" prop="es" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.es" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_ja')" prop="ja" style="width: 650px">
                        <Input type="textarea" :rows="3" v-model="formData.ja" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                 </TabPane>
                 <TabPane :label="$t('firmwareVersion.addBox.title2')">

                     <FormItem :label="$t('appVersion.titleName.version')" prop="version" style="width: 500px">
                        <Input type="text" v-model.trim="formData.version" :placeholder="$t('inputPlaceholder')+$t('appVersion.example')" ></Input>
                    </FormItem>
        
                     <FormItem :label="$t('appVersion.titleName.os')" prop="os" class="ivu-form-item-required" style="width: 500px">
                        <RadioGroup v-model="formData.os">
                            <Radio :label="item.id" v-for="(item) in osList" :key='item.id'>
                                <span>{{item.name}}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>

                    <FormItem v-if="formData.os==2"  :label="$t('appVersion.titleName.innerLink')" prop="innerLink" style="width: 500px">
                        <Input type="text" v-model.trim="formData.innerLink" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
        
                     <FormItem :label="$t('appVersion.titleName.releaseType')" class="ivu-form-item-required" prop="releaseType" style="width: 500px">
                        <RadioGroup v-model="formData.releaseType">
                            <Radio :label="item.id" v-for="(item) in typeList" :key='item.id'>
                                <span>{{item.name}}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>
        
        
        
                    <FormItem :label="$t('appVersion.titleName.fileName')" prop="fileName" class="ivu-form-item-required" style="width: 500px">
                        <upload-file ref='upFile' :num='1' :action='upFileUrl' :types='["apk","ipa"]'  :formatError="$t('appVersion.require.formatError')" @setThumbUrl='setThumbUrl'></upload-file>
                    </FormItem>
        
                    <FormItem>
                        <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                        <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                    </FormItem>
                </TabPane>
             </Tabs>

        </Form>

    <!-- </Modal> -->
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import uploadFile from '../../common/uploadFiles.vue'
import {mapState} from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            offModel: Boolean
        },
        name: "Model3",
        components: {
            uploadFile
        },
        data() {
            return {   
                upFileUrl:this.config.urlArray.uploadImg,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    os:'1',
                    osType: "1",
                    releaseType:'1',
                    innerLink:'',
                    version: '',
                    fileId:'',
                    fileName:'',
                    updateInformation:'',
                    zh:'',
                    zh_ft:'',
                    en:'',
                    fr:'',
                    de:'',
                    es:'',
                    ja:'',
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val === true) {   
                   this.formData.os = this.editFormData.os
                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    this.$refs.upFile.clearImg()
                }
            },
        },
        computed:{
 
            ...mapState(['local','selectId']),
            osList(){
                return [
                    {id:'1',name:'andrios'},
                    {id:'2',name:'ios'},
                ]
            },
            typeList(){
                 return [
                    {id:'1',name:this.$t('selectList.releaseTypeList.beta')},
                    {id:'2',name:this.$t('selectList.releaseTypeList.release')},
                ]
            },
             ruleCustom(){
                 return {//验证
                    version: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {required: true, RegExp:'^([1-9]\d|[1-9])(\.([0-9]\d|\d)\.([1-9]))$',message: this.$t('required'),trigger: 'blur' },
                    ],
                    innerLink: [
                        {type: 'string', pattern: /^[a-zA-z]+:\/\/[^\s]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
        
                    suitDeviceType: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    zh: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    zh_ft: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    en: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    fr: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    de: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    es: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    ja: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                }
             },


        },
        created(){
           
        },
        methods: {
            setThumbUrl(obj){
                // console.log(obj)
               this.formData.fileId = obj.data
               this.formData.fileName = obj.file.name
            },
            subData(name) {//提交表单
                
                if(!this.formData.fileId){
                    common.msg('error',this.$t('appVersion.titleName.fileName')+this.$t('required'))
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.formData.osType = this.formData.os
                        this.formData.updateInformation = '#'+'&zh&'+this.formData.zh+'&zh&'
                                                             +'&zh_TW&'+this.formData.zh_ft+'&zh_TW&'
                                                             +'&zh_HK&'+this.formData.zh_ft+'&zh_HK&'
                                                             +'&en&'+this.formData.en+'&en&'
                                                             +'&fr&'+this.formData.fr+'&fr&'
                                                             +'&de&'+this.formData.de+'&de&'
                                                             +'&es&'+this.formData.es+'&es&'
                                                             +'&ja&'+this.formData.ja+'&ja&'
                                                             +'#'
                        // console.log(this.formData)
                        this.axios.post(this.config.urlArray.appsAdd, {...this.formData,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false})
                        
                        }).catch((err) => {
                            this.disabled = false
                            console.log(err)
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                // this.$emit('update:showModel',false);
                // this.$emit('update:offModel',true);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
                this.formData.os = '1'
                this.formData.osType = '1'
                this.formData.releaseType = '1'
                this.formData.updateInformation = ''
                this.formData.innerLink = ''
                this.formData.fileId = ''
                this.formData.fileName = ''
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
